// src/hooks/useAuthSession.js — the active Lunexx session ({ token,
// walletAddress, expiresAt, method: 'wallet' | 'email', email }) or null,
// re-rendered on every change (login, email sign-in, logout).
import { useSyncExternalStore } from 'react';
import { authService } from '../services/AuthService';

const subscribe = (fn) => authService.subscribe(fn);
const snapshot = () => authService.getSessionSnapshot();

export function useAuthSession() {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
